module.exports = __webpack_public_path__ + "static/media/expert-olga.380b9314.png";